'use strict';

frontendApp.directive('iioInputNotice', [function() {

    return {
        require: 'ngModel',
        restrict:'A',
        replace: false,
        scope: {
            hasInputError: '='
        },
        
        link: function(scope, element, attrs, ngModelCtrl) {

            var container = $(element).parent('.filter');

            var currentColors = {
                'background': '',
                'border': ''
            };

            $(element).css({
                "-webkit-transition": "background-color 500ms linear",
                "-moz-transition": "background-color 500ms linear",
                "-o-transition": "background-color 500ms linear",
                "-ms-transition": "background-color 500ms linear",
                "transition": "background-color 500ms linear"
            });
            
            scope.$watch(function () {
                return ngModelCtrl.$modelValue;
            }, function (modelValue) {
                if (modelValue) {
                    $(container).addClass('input-append');
                    $(element).css({
                        'backgroundColor' : currentColors.background,
                        'borderColor' : currentColors.border
                    });

                } else {
                    $(container).removeClass('input-append');
                    $(element).css({
                        'backgroundColor' : '',
                        'borderColor': ''
                    });
                }
            });

            scope.$watch('hasInputError', function(val) {
                if (val == true) {
                    // Error Colors
                    currentColors.background = '#f2dede';
                    currentColors.border = '#a94442'
                } else {
                    // Success Colors
                    currentColors.background = '#fcf8e3';
                    currentColors.border = '#c09853'
                }

                // If we have value in this input, apply the CSS immediately
                if (ngModelCtrl.$modelValue) {
                    $(element).css({
                        'backgroundColor' : currentColors.background,
                        'borderColor' : currentColors.border
                    });
                }
            });

        }
    }
}]);
